module.exports = __webpack_public_path__ + "img/activity-control.78f418c9.svg";